import { useEffect } from 'react';
import { useStore } from 'providers';
import { useAddToHomeScreen, useFetchFromService, useRafLink } from 'hooks';

const GlobalData = () => {
  const { store } = useStore();
  const { userData, vouchersData } = store;

  const fetchUserData = useFetchFromService('userData');
  const fetchVouchersData = useFetchFromService('vouchersData');

  useAddToHomeScreen();
  useRafLink();

  useEffect(() => {
    if (!userData) fetchUserData();
  }, [userData, fetchUserData]);

  useEffect(() => {
    if (!vouchersData) fetchVouchersData();
  }, [userData, vouchersData, fetchVouchersData]);

  return null;
};

export default GlobalData;
